// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemCatalogQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  order?: Types.InputMaybe<Types.BidItemOrder>;
  filter?: Types.InputMaybe<Types.BidItemFilter>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ItemCatalogQuery = { __typename?: 'Query', bidItemsPage: { __typename?: 'BidItemsPage', bidItems: Array<{ __typename?: 'BidItem', code: string, id: string, name: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, items: Array<{ __typename?: 'Item', displayName: string, fullCode: string, id: string, name: string }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type ItemCatalogDetailsFragment = { __typename?: 'BidItem', code: string, id: string, name: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, items: Array<{ __typename?: 'Item', displayName: string, fullCode: string, id: string, name: string }> };

export const ItemCatalogDetailsFragmentDoc = gql`
    fragment ItemCatalogDetails on BidItem {
  ...Named
  code
  costType {
    code
    name
  }
  unitOfMeasure {
    ...Named
  }
  items {
    ...Named
    displayName
    fullCode
  }
}
    ${NamedFragmentDoc}`;
export const ItemCatalogDocument = gql`
    query ItemCatalog($first: Int, $order: BidItemOrder, $filter: BidItemFilter, $offset: Int) {
  bidItemsPage(first: $first, order: $order, filter: $filter, offset: $offset) {
    bidItems {
      ...ItemCatalogDetails
    }
    pageInfo {
      hasNextPage
      totalCount
    }
  }
}
    ${ItemCatalogDetailsFragmentDoc}`;

/**
 * __useItemCatalogQuery__
 *
 * To run a query within a React component, call `useItemCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCatalogQuery({
 *   variables: {
 *      first: // value for 'first'
 *      order: // value for 'order'
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useItemCatalogQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemCatalogQuery, ItemCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemCatalogQuery, ItemCatalogQueryVariables>(ItemCatalogDocument, options);
      }
export function useItemCatalogLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemCatalogQuery, ItemCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemCatalogQuery, ItemCatalogQueryVariables>(ItemCatalogDocument, options);
        }
// @ts-ignore
export function useItemCatalogSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ItemCatalogQuery, ItemCatalogQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemCatalogQuery, ItemCatalogQueryVariables>;
export function useItemCatalogSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemCatalogQuery, ItemCatalogQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemCatalogQuery | undefined, ItemCatalogQueryVariables>;
export function useItemCatalogSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemCatalogQuery, ItemCatalogQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemCatalogQuery, ItemCatalogQueryVariables>(ItemCatalogDocument, options);
        }
export type ItemCatalogQueryHookResult = ReturnType<typeof useItemCatalogQuery>;
export type ItemCatalogLazyQueryHookResult = ReturnType<typeof useItemCatalogLazyQuery>;
export type ItemCatalogSuspenseQueryHookResult = ReturnType<typeof useItemCatalogSuspenseQuery>;
export type ItemCatalogQueryResult = Apollo.QueryResult<ItemCatalogQuery, ItemCatalogQueryVariables>;